var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69783 0H9.64703L15.5277 6.13834V18.0588C15.5277 19.5518 14.3228 20.7643 12.8299 20.7643H2.69783C1.2125 20.7643 4.25738e-10 19.5518 4.25738e-10 18.0588V2.69783C-2.62352e-05 1.2125 1.2125 0 2.69783 0Z",
    fill: "#00733B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9825,
    cy: 17.7247,
    r: 4.27499,
    fill: "#4D9D76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7149 17.8923H15.8142L13.982 19.5578L12.1499 17.8923H13.2492V15.8936H14.7149V17.8923Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63916 0V6.08529H15.5274L9.63916 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45631 12.6756H5.44842L4.75881 11.5161L4.06919 12.6756H3.05371L4.25108 10.6598L3.19772 8.90921H4.21317L4.75879 9.81859L5.29683 8.90921H6.3123L5.2665 10.6674L6.45631 12.6756ZM6.81248 12.6756V8.90921H7.77491V11.8571H9.4118V12.6756H6.81248V12.6756ZM11.0032 12.7211C10.6243 12.7211 10.2909 12.5998 10.0029 12.3649C9.72251 12.1375 9.56339 11.8496 9.54064 11.5086L10.3667 11.2661C10.3894 11.4479 10.4652 11.6071 10.594 11.7283C10.7304 11.8496 10.882 11.9102 11.0487 11.9102C11.1851 11.9102 11.2988 11.8799 11.3897 11.8193C11.4731 11.7586 11.5185 11.6753 11.5185 11.5768C11.5185 11.4934 11.4807 11.4252 11.4124 11.3646C11.3442 11.3115 11.2533 11.2661 11.1472 11.2282C11.0411 11.1903 10.9123 11.1524 10.7834 11.1221C10.647 11.0842 10.5106 11.0387 10.3818 10.9781C10.2454 10.925 10.1241 10.8568 10.0181 10.7735C9.90437 10.6977 9.82102 10.584 9.75281 10.44C9.6846 10.3036 9.64671 10.1369 9.64671 9.94746C9.64671 9.63675 9.77553 9.37909 10.0408 9.17448C10.306 8.96228 10.6243 8.86377 10.9956 8.86377C11.367 8.86377 11.6928 8.9547 11.9656 9.12901C12.2384 9.31088 12.4127 9.54582 12.4809 9.83378L11.617 10.1975C11.5791 10.0384 11.5034 9.90957 11.3973 9.81106C11.2912 9.72013 11.1548 9.66708 10.9956 9.66708C10.8744 9.66708 10.7834 9.69738 10.7077 9.74287C10.6394 9.78834 10.6091 9.85655 10.6091 9.9399C10.6091 10.0157 10.6546 10.0839 10.7455 10.1369C10.8365 10.1824 10.9577 10.2203 11.0941 10.243C11.2305 10.2658 11.3821 10.3037 11.5412 10.3567C11.708 10.4173 11.8519 10.478 11.9959 10.5613C12.1323 10.6371 12.246 10.7659 12.3369 10.9327C12.4354 11.107 12.4809 11.3116 12.4809 11.5465C12.4809 11.8951 12.3445 12.1831 12.0717 12.3952C11.7989 12.6074 11.4428 12.7211 11.0032 12.7211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.dc59091305c1e0f0282bc57d5935820a.svg";
export { ForwardRef as ReactComponent };